import { gql } from "@apollo/client";

export const UPLOAD_FILE = gql`
  mutation uploadFile($file: Upload!, $path: String) {
    singleUpload(file: $file, path: $path)
  }
`;

export const DELETE_FILE = gql`
  mutation fileDelete($path: String!) {
    fileDelete(path: $path)
  }
`;

export default UPLOAD_FILE;
